import layoutStyle from './Layout.module.scss';
import "@fortawesome/fontawesome-free/css/all.css";
import { SideMenu } from "../../components/SideMenu/SideMenu";
import { Player } from "../../components/Player/Player";

type LayoutProps = {
    children?: React.ReactNode,
    trackList: any,
    albumTitle: string,
    cover: string
}

const data = [
    {
        title: "Mi Librería",
        links: [
            { name: "Recientes", link: "#Recientes" },
            { name: "Artistas", link: "#Artistas" },
            { name: "Albums", link: "#Albums" },
            { name: "Canciones", link: "#Canciones" },
            { name: "Estaciones", link: "#Estaciones" },
        ]
    },
    {
        title: "Playlist",
        links: [
            { name: "Metal", link: "#Metal" },
            { name: "Para bailar", link: "#Para_bailar" },
            { name: "Rock 90s", link: "#Rock_90s" },
            { name: "Baladas", link: "#Baladas" },
        ]
    }
]

export const Layout = ({ children, trackList, albumTitle, cover }: LayoutProps) => {
    return (
        <div className={layoutStyle.layout}>
            <SideMenu sections={data} className={layoutStyle.sideMenu} />
            {children}
            <Player
                cover={cover}
                trackList={trackList}
                albumTitle={albumTitle} />
        </div>
    )
}